export enum HospitalizationBenefits {
    FIRST_DAY = "First day hospital (admission)",
    FIRST_DAY_ICU = "First day hospital - intensive care unit (admission)",
    DAILY_CONFINEMENT = "Daily hospital confinement",
    DAILY_CONFINEMENT_ICU = "Daily hospital confinement - intensive care unit"
}